







































import Vue from "vue";
import { DataAttribute, DataItem } from "@/model/DataViewConfigurationHelper";

function cloneOrNewItem(item: DataItem | null): DataItem {
  const newItem: DataItem = { attributes: {} };
  if (item) {
    newItem.id = item.id;
    newItem.attributes = { ...item.attributes };
  }

  return newItem;
}

export default Vue.extend({
  name: "InputForm",

  props: {
    itemToEdit: {
      type: Object as () => DataItem,
      required: false
    },
    dataAttributes: {
      type: Array as () => DataAttribute[],
      required: true
    }
  },

  watch: {
    itemToEdit() {
      this.item = cloneOrNewItem(this.itemToEdit);
    }
  },

  computed: {
    isEditMode(): boolean {
      return !!this.item.id;
    },
    formTitle(): string {
      return this.isEditMode ? "Eintrag bearbeiten" : "Neuer Eintrag";
    }
  },

  methods: {
    saveItem() {
      this.$emit("submit", this.item);
      this.item = cloneOrNewItem(null);
      if (this.isEditMode || this.closeAfterSave) {
        this.$emit("close");
      }
    }
  },

  data() {
    return {
      item: cloneOrNewItem(this.itemToEdit),
      closeAfterSave: true
    };
  }
});
